import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ExhibitScheduleType =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ExhibitScheduleType, _BaseData);

  function ExhibitScheduleType() {
    _classCallCheck(this, ExhibitScheduleType);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExhibitScheduleType).call(this, "ExhibitScheduleType"));
  }

  return ExhibitScheduleType;
}(BaseData);

export default new ExhibitScheduleType();